import React, { useContext, useState, useEffect } from "react";
import "./rating.css";
import imoji from "../../images/imoji.png";
import { AiFillStar } from "react-icons/ai";
import axios from "axios";
import RatingContext from "../RatingContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, baseLocal } from "../../context/BaseUrl";

const Rating = (props) => {
  // const { ratings, setRatings } =

  const [ratingAverage, setRatingAverage] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [data, setData] = useState(null);

  const [Val1, setVal1] = useState(0);
  const [Val2, setVal2] = useState(0);
  const [Val3, setVal3] = useState(0);
  const [Val4, setVal4] = useState(0);
  const [Val5, setVal5] = useState(0);
  const [Val6, setVal6] = useState(0);
  const [Val7, setVal7] = useState(0);
  const [Val8, setVal8] = useState(0);
  const [Val9, setVal9] = useState(0);
  const [Val10, setVal10] = useState(0);

  const resetSelect = () => {
    setVal1(0);
    setVal2(0);
    setVal3(0);
    setVal4(0);
    setVal5(0);
    setVal6(0);
    setVal7(0);
    setVal8(0);
    setVal9(0);
    setVal10(0);
  };

  const handleSent = async () => {
    try {
      let user = localStorage.getItem("user");

      if (!user) {
        toast.error("You are not logged in.");
        return;
      }

      user = JSON.parse(user);
      const user_id = user.user._id;
      const token = user.token;

      const response = await fetch(`${baseUrl}/user/sidebar/sidebarrating`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          val1: Val1,
          val2: Val2,
          val3: Val3,
          val4: Val4,
          val5: Val5,
          val6: Val6,
          val7: Val7,
          val8: Val8,
          val9: Val9,
          val10: Val10,
          obj_id: props.institute_id,
          user_id: user_id,
          overall:
            Number(Val1) +
            Number(Val2) +
            Number(Val3) +
            Number(Val4) +
            Number(Val5) +
            Number(Val6) +
            Number(Val7) +
            Number(Val8) +
            Number(Val9) +
            Number(Val10),
        }),
      });

      const result = await response.json();
      setLoading(false);
      if (result) {
        toast.success(result);

        fetchData();
        resetSelect();
      }
    } catch (error) {
      console.log(error);
      //   resetSelect();

      setLoading(false);
    }
  };

  async function fetchData() {
    const response = await axios.get(
      `${baseLocal}/user/sidebar/getsidebarrating/${props.institute_id}`
    );
    setData(response.data);
    console.log(response.data);
    setRatingAverage(response.data.ratingAvg);
  }

  useEffect(() => {
    fetchData();
  }, [props.institute_id]);

  return (
    <React.Fragment>
      <div className="rating-page">
        <div className="review">
          <h6>Reviews</h6>
          <h1></h1>
          <p>Overall Rating (Out of 10)</p>
          <div className="well well-sm container-fluid">
            <div className="row">
              {/* {data.map(item=>( */}
              <div className="col-xs-12 col-md-6 text-center">
                <h1 className="rating-num">
                  {ratingAverage ? ratingAverage.rating : 0}
                </h1>
                <div className="rating">
                  <AiFillStar size={20} />
                  <AiFillStar size={20} />
                  <AiFillStar size={20} />
                  <AiFillStar size={20} />
                  <AiFillStar size={20} className="color" />
                </div>
                <div>
                  <span className=" parah">
                    Based on{" "}
                    {ratingAverage ? ratingAverage.totalRatingCount : 0}{" "}
                    Verified Reviews
                  </span>
                </div>
              </div>
              {/* ))} */}
              <div className="col-xs-12 col-md-6">
                <div className="row rating-desc">
                  {data &&
                    data.progressRating.map((item) => {
                      return (
                        <React.Fragment>
                          <div className="col-8 col-md-9 d-flex align-items-center mb-2">
                            <span className="sr-only">{item.percent}%</span>
                            <div className="progress progress-striped w-100">
                              <div
                                className="progress-bar progress-bar-success"
                                role="progressbar"
                                aria-valuenow={item.percent}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: `${item.percent}%` }}
                              ></div>
                            </div>
                          </div>
                          <div className="col-4 col-md-3 text-right mb-2">
                            {item.label} <AiFillStar />
                          </div>
                        </React.Fragment>
                      );
                    })}

                  {/* end 1 */}
                </div>
                {/* end row  */}
              </div>
            </div>
          </div>
        </div>

        <div className="rate container-fluid">
          <h6>Rate Us</h6>
          {/* <p>How to start UPSC Preparation from Zero Level?</p>
                    <img src={imoji} alt='imoji' />
                    <p>How to start UPSC Preparation from Zero Level?</p>
                    <img src={imoji} alt='imoji' />
                    <p>How to start UPSC Preparation from Zero Level?</p>
                    <img src={imoji} alt='imoji' />
                    <p>How to start UPSC Preparation from Zero Level?</p>
                    <img src={imoji} alt='imoji' /> */}
          <div className="row justify-content-between" >
            <div
              onClick={(e) => setVal1(() => (Val1 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val1 && "active"}`}
            >
              <input id="val1" type="checkbox" value={Val1} />
              Faculty
            </div>
            <div
              onClick={(e) => setVal2(() => (Val2 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val2 && "active"}`}
            >
              <input id="val2" type="checkbox" value={Val2} />
              City
            </div>

            <div
              onClick={(e) => setVal3(() => (Val3 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val3 && "active"}`}
            >
              <input id="val3" type="checkbox" value={Val3} />
              Infrastructutre
            </div>

            <div
              onClick={(e) => setVal4(() => (Val4 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val4 && "active"}`}
            >
              <input id="val4" type="checkbox" value={Val4} />
              Outbonding Process
            </div>

            <div
              onClick={(e) => setVal5(() => (Val5 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val5 && "active"}`}
            >
              <input id="val5" type="checkbox" value={Val5} />
              Fees Stucture
            </div>

            <div
              onClick={(e) => setVal6(() => (Val6 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val6 && "active"}`}
            >
              <input id="val6" type="checkbox" value={Val6} />
              Counselling
            </div>

            <div
              onClick={(e) => setVal7(() => (Val7 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val7 && "active"}`}
            >
              <input id="val7" type="checkbox" value={Val7} />
              Course Rating
            </div>

            <div
              onClick={(e) => setVal8(() => (Val8 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val8 && "active"}`}
            >
              <input id="val8" type="checkbox" value={Val8} />
              Online Faculty
            </div>

            <div
              onClick={(e) => setVal9(() => (Val9 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val9 && "active"}`}
            >
              <input id="val9" type="checkbox" value={Val9} />
              Job Gaurentee
            </div>

            <div
              onClick={(e) => setVal10(() => (Val10 == 1 ? 0 : 1))}
              className={`checkbox-container col-md-6 mb-2 ${Val10 && "active"}`}
            >
              <input id="val10" type="checkbox" value={Val10} />
              Review
            </div>
          </div>
        </div>
        <button onClick={handleSent}>{Loading ? "loading" : "submit"}</button>
      </div>
    </React.Fragment>
  );
};

export default Rating;
